import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(function (theme) {
  return {
    root: {},
    select: {
      height: theme.typography.pxToRem(22),
      lineHeight: 1.25,
      paddingTop: 13,
      paddingBottom: 13,
      // needed to override the mui one since it is more specific
      '&&': {
        paddingRight: theme.spacing(6)
      },
      [theme.breakpoints.up(1024)]: {
        height: '1.3333333em',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
      },
      '&:focus': {
        backgroundColor: 'transparent'
      }
    },
    icon: {
      color: theme.palette.denim[500],
      right: theme.spacing(2),
      '.Mui-disabled &': {
        color: theme.palette.stainless[700]
      }
    },
    disabled: {}
  };
}, {
  name: 'PdsSelect'
});